import { forwardRef } from 'react';
import { IconProps } from '../iconTypes';
const SVGIcon = forwardRef<SVGSVGElement, IconProps>(({
  size = 14,
  ...props
}, svgRef) => {
  if (size) {
    props.width = size;
    props.height = size;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" viewBox="0 0 384 512" ref={svgRef} {...props}><path d="M192 464c-79.5 0-144-64.5-144-144 0-13 5.1-33.5 17-61.1 11.5-26.6 27.6-55.8 45.5-84.7 29-46.8 61-90.2 81.5-117 20.5 26.7 52.6 70.2 81.5 117 17.9 28.9 34 58 45.5 84.7 11.9 27.6 17 48.2 17 61.1 0 79.5-64.5 144-144 144zM0 320c0 106 86 192 192 192s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 57.4 46.6 104 104 104 13.3 0 24-10.7 24-24s-10.7-24-24-24c-30.9 0-56-25.1-56-56z" /></svg>;
});
SVGIcon.displayName = "RegularDroplet";
export default SVGIcon;